import { render, staticRenderFns } from "./sysStudentScore.vue?vue&type=template&id=a11007cc&"
import script from "./sysStudentScore.vue?vue&type=script&lang=js&"
export * from "./sysStudentScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports